import TopContentMessage from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopContentMessage/TopContentMessage';
import { createStructuredSelector, createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import TopContentFreeReturnsEN from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/locales/TopContentFreeReturns_en_US';
import TopContentFreeReturnsFR from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/locales/TopContentFreeReturns_fr_CA';
const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(TopContentFreeReturnsEN, TopContentFreeReturnsFR);

const localization = createStructuredSelector({
    infoIcon: getTextFromResource(getText, 'infoIcon')
});

const fields = createSelector(localization, locale => {
    return {
        localization: locale
    };
});

const withTopContentMessageProps = wrapHOC(connect(fields, null));

export default withTopContentMessageProps(TopContentMessage);
